import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // First try to use Lenis to scroll to top immediately if it's initialized
        if (window.lenis) {
            window.lenis.scrollTo(0, { immediate: true });
        } else {
            // Fallback for native scrolling
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
